import React from "react";
import ContentWrapper from "@/res/components/ClientCreate/content-wrapper";
import { Trans, useTranslation } from "react-i18next";

const ContentInDev = (props) => {
    const [t] = useTranslation();

    return (
        <ContentWrapper title="Not yet ready" {...props}>
            <h2>
                {t("pages.start.in-development.header")}
            </h2>
            <p>
                <Trans i18nKey="pages.start.in-development.description">
                    <span className="show-desktop"/>
                    <span className="hide-desktop"/>
                </Trans>
            </p>
        </ContentWrapper>
    );
};

export default ContentInDev;
